import * as zod from 'zod'

type BreakTimeBounds = {
  clockedInAt?: string
  clockedOutAt?: string
}

export const getEditBreakSchema = ({
  clockedInAt,
  clockedOutAt,
}: BreakTimeBounds = {}) =>
  zod
    .object({
      action: zod.enum(['take', 'waive', 'missed']),
      startTime: zod.string(),
      endTime: zod.string(),
      reason: zod.string(),
    })
    .superRefine((data, ctx) => {
      if (data.action !== 'take') {
        return
      }
      if (!data.startTime) {
        ctx.addIssue({
          code: zod.ZodIssueCode.custom,
          message: 'Start time is required.',
          path: ['startTime'],
        })
      }
      if (!data.endTime) {
        ctx.addIssue({
          code: zod.ZodIssueCode.custom,
          message: 'End time is required.',
          path: ['endTime'],
        })
      }
      // All times are `yyyy-MM-ddTHH:mm` in the same timezone, so they sort as strings.
      if (data.startTime && data.endTime && data.endTime <= data.startTime) {
        ctx.addIssue({
          code: zod.ZodIssueCode.custom,
          message: 'End time must be after start time.',
          path: ['endTime'],
        })
      }
      if (clockedInAt && data.startTime && data.startTime < clockedInAt) {
        ctx.addIssue({
          code: zod.ZodIssueCode.custom,
          message: 'Start time must be at or after clock in.',
          path: ['startTime'],
        })
      }
      if (clockedOutAt && data.endTime && data.endTime > clockedOutAt) {
        ctx.addIssue({
          code: zod.ZodIssueCode.custom,
          message: 'End time must be at or before clock out.',
          path: ['endTime'],
        })
      }
    })

export type EditBreakSchema = zod.infer<ReturnType<typeof getEditBreakSchema>>
